/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from "react";
import styles from "./input.module.scss";

interface Props {
  label?: any;
  error?: any;
  success?: any;
  type?: any;
  value?: any;
  onChange?: any;
  onBlur?: any;
  disabled?: any;
  pattern?: any;
  maxLength?: any;
  placeholder?: any;
  className?: any;
  id?: any;
  children?: any;
  validator?: any;
  validationErrorMessages?: any;
}

export const Input: FC<Props> = ({
  label = "",
  error,
  success,
  type = "text",
  value = "",
  onChange = (e) => {},
  onBlur = (e) => {},
  disabled,
  pattern,
  maxLength,
  placeholder,
  className,
  id: idProp,
  children,
  validator = (e, messages) => ({}),
  validationErrorMessages,
}) => {
  const [val, setVal] = useState(value);
  const [displayedError, setDisplayedError] = useState(false);
  const [showError, setShowError] = useState(!!error);
  const id = idProp || label.toLowerCase().replace(/\s+/g, "-");
  const fieldClassName =
    (displayedError && showError) || error
      ? styles.fieldError
      : success
      ? styles.fieldSuccess
      : styles.field;

  const change = (event) => {
    setVal(event.target.value);
    setShowError(false);
    const validationError = validator(
      event.target.value,
      validationErrorMessages,
    );
    setDisplayedError((validationError as any).error);
    onChange({
      value: event.target.value,
      error: (validationError as any).error,
      success: (validationError as any).isValid,
      ...event,
    });
  };

  const blur = (event) => {
    if (displayedError || error) {
      setShowError(true);
    }
    onBlur(event);
  };

  /* eslint-disable jsx-a11y/label-has-for */
  return (
    <div className={`${styles.input} input-${id} ${className}`}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}

      <input
        type={type}
        id={id}
        name={id}
        className={fieldClassName}
        value={val}
        pattern={pattern}
        onChange={change}
        onBlur={blur}
        disabled={disabled}
        maxLength={maxLength}
        placeholder={placeholder}
      />

      {children}
      {((displayedError && showError) || error) && (
        <div className={`body02 ${styles.error}`}>
          {error || displayedError}
        </div>
      )}
    </div>
  );
};
/* eslint-enable @typescript-eslint/no-explicit-any */
